const Svg = {
  add: require("./add.svg"),
  attachment: require("./attachment.svg"),
  call: require("./call.svg"),
  call_primary: require("./call_primary.svg"),
  clear: require("./clear.svg"),
  chat_aja: require("./chat_aja.svg"),
  chevron_right: require("./chevron_right.svg"),
  dropdown: require("./dropdown.svg"),
  delete: require("./delete.svg"),
  edit: require("./edit.svg"),
  edit_app: require('./edit_app.svg'),
  monitoring: require("./monitoring.svg"),
  email: require("./email.svg"),
  ic_close: require("./ic_close.svg"),
  info_outline: require("./info_outline.svg"),
  more_vert: require("./more_vert.svg"),
  search: require("./search.svg"),
  sms_otp: require("./sms_otp.svg"),
  sms: require("./sms.svg"),
  sms_primary: require("./sms_primary.svg"),
  whatsapp: require("./whatsapp.svg"),
  whatsapp_primary: require("./whatsapp_primary.svg"),
  view_column: require("./view_column.svg"),
  view_list: require("./view_list.svg"),
  feedback_like: require("./feedback_like.svg"),
  feedback_unlike: require("./feedback_unlike.svg"),
  arrow_drop_down: require("./arrow_drop_down.svg"),
  download: require("./download.svg"),
  chevron_right_2: require("./chevron_right_2.svg"),
  calender: require("./calender.svg"),
  whatsapp_2: require("./whatsapp_2.svg"),
  sms_dashboard: require("./sms_dashboard.svg"),
  voice: require("./voice.svg"),
  arrow_up: require("./arrow_up.svg"),
  arrow_down: require("./arrow_down.svg"),
  layer_checklist_1: require("./layer_checklist_1.svg"),
  layer_checklist_2: require("./layer_checklist_2.svg"),
  layer_checklist_3: require("./layer_checklist_3.svg"),
  layer_info_1: require("./layer_info_1.svg"),
  layer_info_2: require("./layer_info_2.svg"),
  layer_info_3: require("./layer_info_3.svg"),
  checklist: require("./checlist.svg"),
  check_true: require("./check_true.svg"),
  check_false: require("./check_false.svg"),
  locked: require("./locked.svg"),
  log_out: require("./log_out.svg"),
  u_bag: require("./u_bag-alt.svg"),
  user: require("./user.svg"),
  locked_active: require("./locked_active.svg"),
  u_bag_active: require("./u_bag-alt_active.svg"),
  user_active: require("./user_active.svg"),
  download_v2: require("./download_v2.svg"),
  menu: require("./menu.svg"),
  error: require("./error.svg"),
  refresh: require('./refresh.svg'),
  chevron: require('./chevron.svg'),
  slash_hide: require('./u_eye_splash_hide.svg'),
  slash_show: require('./u_eye-slash_show.svg'),
  refreshinactive: require('./refreshinactive.svg'),
  overview_inactive: require('./overview_active.svg'),
  overview_in: require('./overview_in.svg'),
  app_active: require('./application_active.svg'),
  app_inactive: require('./application_inactive.svg'),
  generate_inactive: require('./generate_inactive.svg'),
  generate_active: require('./generate_active.svg'),
  api_doc_active: require('./api_document_active.svg'),
  api_doc_inactive: require('./api_document_inactive.svg'),
  chevron_lefth: require('./chevron_lefth.svg'),
  chevron_lefth_active: require('./chevron_lefth_active.svg'),
  chevron_rightV2: require('./chevron_rightV2.svg'),
  checkbox_custom: require('./ic-check.svg'),
  wa_active: require('./wa_active.svg'),
  wa_nonactive: require('./wa_nonactive.svg'),
  dots_inactive: require('./dots_in.svg'),
  dots_active: require('./dots_active.svg'),
  duplicate: require('./duplicate.svg'),
  deleted: require('./deleted.svg'),
  preview: require('./preview.svg'),
  help: require('./help.svg'),
  // channel_manage_active: require('./channel_manage_active.svg'),
  // channel_manage_inactive: require('./channel_manage_inactive.svg'),
  whatsapp_active: require('./whatsapp_active.svg'),
  // action_edit: require('./action_edit.svg'),
  facebook: require('./facebook.svg'),
  // next_step_channel: require('./next_step_channel.svg'),
  info: require('./info.svg'),
  success_alert: require('./success_alert.svg'),
  // edit_app: require('./edit_app.svg'),
  setting: require('./setting.svg'),
  ind_flag: require('./ind_flag.svg'),
  whatsapp_editor: require('./whatsapp_editor.svg'),
  check_success: require('./check_success.svg'),
  megaphone: require('./megaphone.svg'),
  bell: require('./bell.svg'),
  key_skeleton: require('./key_skeleton.svg'),
  categories_marketing: require('./categories_marketing.svg'),
  categories_utility: require('./categories_utility.svg'),
  categories_authentication: require('./categories_authentication.svg'),
  monospace: require('./monospace.svg'),
  copycode: require('./copy-code.svg'),
  autofill: require('./autofill.svg'),
  copycodeblue: require('./copy-code-blue.svg'),
  notif_active: require('./notif_active.svg'),
  notif_inactive: require('./notif_inactive.svg'),
  arrow_left: require("./arrow_left.svg"),
};

export default Svg;
